<template>
  <div class="container-fluid">
    <b-form @submit="onSubmit">
      <div class="contents event_edit">
        <div class="start-m border-top-dgray">
          <div class="row g-0 border-bottom">
            <div class="col-lg-3 bg-gray row g-0 align-items-center">
              <label>{{ $t("title.common.title") }}</label>
            </div>
            <div class="col-lg-9">
              <input
                type="text"
                :placeholder="$t('title.brandroom.minigame_title')"
                name="title"
                required
                v-model="form.title"
              />
            </div>
          </div>
          <div class="row g-0 border-bottom">
            <div class="col-lg-3 bg-gray row g-0 align-items-center">
              <label>{{ $t("title.event.message") }}</label>
            </div>
            <div class="col-lg-9">
              <input
                type="text"
                :placeholder="$t('title.brandroom.minigame_screen_message')"
                name="message"
                required
                v-model="form.message"
              />
            </div>
          </div>
          <div class="row g-0 border-bottom">
            <div class="col-lg-3 bg-gray row g-0 align-items-center">
              <label>{{ $t("title.common.bucks") }}</label>
            </div>
            <div class="col-lg-9">
              <input
                type="text"
                placeholder=""
                name="point"
                required
                v-model="form.point"
                class="point"
              />
            </div>
          </div>
          <div class="row g-0 border-bottom">
            <div class="col-lg-3 bg-gray row g-0 align-items-center">
              <label>{{ $t("title.common.period") }}</label>
            </div>
            <div class="col-lg-9 period">
              <input
                type="date"
                class="form-control-lg"
                required
                v-model="form.startdate"
              />
              <input
                type="date"
                class="form-control-lg"
                required
                v-model="form.enddate"
              />
            </div>
          </div>
          <div class="row g-0 border-bottom">
            <div class="col-lg-3 bg-gray row g-0 align-items-center">
              <label>{{ $t("title.event.system_range4") }}</label>
            </div>
            <div class="col-lg-9">
              <select class="" v-model="form.systemrange">
                <option value="0">{{ $t("title.common.total") }}</option>
              </select>
            </div>
          </div>
          <div class="row g-0 border-bottom">
            <div class="col-lg-3 bg-gray row g-0 align-items-center">
              <label>{{ $t("title.event.minigametype") }}</label>
            </div>
            <div class="col-lg-9">
              <select
                class=""
                v-model="form.type"
                @change="change_type($event)"
              >
                <option value="1">{{ $t("filter.event.holeinone") }}</option>
                <option value="2">{{ $t("filter.event.albatross") }}</option>
                <option value="3">{{ $t("filter.event.eagle_p5") }}</option>
                <option value="4">{{ $t("filter.event.birdie_p5") }}</option>
                <option value="5">{{ $t("filter.event.par_p5") }}</option>
                <option value="6">{{ $t("filter.event.eagle_p4") }}</option>
                <option value="7">{{ $t("filter.event.birdie_p4") }}</option>
                <option value="8">{{ $t("filter.event.par_p4") }}</option>
                <option value="9">{{ $t("filter.event.longest") }}</option>
                <option value="10">{{ $t("filter.event.nearpin") }}</option>
              </select>
            </div>
          </div>
          <div v-if="distance_yn === 'y'" class="row g-0 border-bottom">
            <div class="col-lg-3 bg-gray row g-0 align-items-center">
              <label class="d-table-cell">{{
                $t("title.common.distance")
              }}</label>
            </div>
            <div class="col-lg-9 d-table">
              <input
                type="text"
                placeholder=""
                name="distance"
                required
                v-model="form.distance"
              />
            </div>
          </div>
          <div class="row g-0 border-bottom">
            <div class="col-lg-3 bg-gray row g-0 align-items-center">
              <label>{{ $t("title.common.Course") }}</label>
            </div>
            <div class="col-lg-9">
              <select class="" v-model="form.courseno" @change="change_cc()">
                <option value="">
                  {{ $t("filter.event.select_golf_course2") }}
                </option>
                <template v-for="(cc, index) in eventcourselist">
                  <option :key="index" :value="cc.courseno">
                    {{ cc.coursename }}
                  </option>
                </template>
              </select>
            </div>
          </div>
          <div class="row g-0 border-bottom lh-48">
            <div class="col-lg-3 bg-gray row g-0 align-items-center">
              <label>{{ $t("title.common.hole") }}</label>
            </div>
            <div class="col-lg-9">
              <p v-if="form.hole">
                {{ form.hole }} {{ $t("title.common.hole") }} [{{
                  $t("title.common.par")
                }}
                {{ cc_par[parseInt(form.hole)] }}]
              </p>
            </div>
          </div>
          <div class="row g-0 border-bottom">
            <div class="col-lg-3 bg-gray row g-0 align-items-center">
              <label>{{ $t("title.event.teebox") }}</label>
            </div>
            <div class="col-lg-9">
              <select class="" v-model="form.teebox">
                <option value="1">{{ $t("filter.common.blue") }}</option>
                <option value="2">{{ $t("filter.common.white") }}</option>
                <option value="3">{{ $t("filter.common.red") }}</option>
                <option value="4">{{ $t("filter.common.yellow") }}</option>
              </select>
            </div>
          </div>
          <div class="row g-0 border-bottom">
            <div class="col-lg-3 bg-gray row g-0 align-items-center">
              <label>{{ $t("title.common.gender") }}</label>
            </div>
            <div class="col-lg-9">
              <select class="" v-model="form.gender">
                <option value="0">{{ $t("filter.common.total") }}</option>
                <option value="M">{{ $t("filter.common.male") }}</option>
                <option value="F">{{ $t("filter.common.female") }}</option>
              </select>
            </div>
          </div>
          <div class="row g-0 border-bottom">
            <div class="col-lg-3 bg-gray row g-0 align-items-center">
              <label>{{ $t("title.common.status") }}</label>
            </div>
            <div class="col-lg-9">
              <select class="" v-model="form.status">
                <option value="0">{{ $t("filter.common.ready") }}</option>
                <option value="1">{{ $t("filter.common.playing") }}</option>
                <option value="2">{{ $t("filter.common.completed") }}</option>
                <option value="3">{{ $t("filter.common.cancel") }}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="btn-bottom-wrapper">
          <b-button
            size="xl"
            variant="outline-primary"
            aria-label="list"
            @click="$router.push({ name: 'MiniGameList' }).catch(() => {})"
            >{{ $t("button.common.list") }}</b-button
          >
          <b-button
            size="xl"
            variant="primary"
            aria-label="Write minigame"
            type="submit"
            >{{ eventno ? $t("button.modify") : $t("button.register") }}
          </b-button>
        </div>

        <div v-if="courseview_yn === 'y'" class="subcourse">
          <div
            v-for="(anc, index1) in courseview.subcourse"
            :key="index1"
            class="course-table"
          >
            <table class="table scorecard_title" width="100%" cellspacing="0">
              <thead class="border-top-0">
                <tr class="">
                  <th>
                    {{ $t("title.event.subcourse") }}{{ anc.subcourseseq }}
                  </th>
                </tr>
                <tr class="bg-gray">
                  <th>{{ $t("title.event.hole") }}</th>
                </tr>
                <tr class="bg-gray">
                  <th>{{ $t("title.event.par") }}</th>
                </tr>
                <tr class="bg-gray">
                  <th>{{ $t("title.event.yard") }}</th>
                </tr>
                <tr class="bg-gray">
                  <th>{{ $t("title.event.chk") }}</th>
                </tr>
              </thead>
            </table>
            <div class="fix-table overflow-x-auto">
              <table class="table scorecard" width="100%" cellspacing="0">
                <thead>
                  <tr>
                    <th colspan="9">{{ anc.subcoursename || "-" }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="bg-gray">
                    <template v-for="(oc, index2) in anc.subcoursehole">
                      <td class="text-black" :key="index2 + 'o'">
                        {{ oc.hole_no }}
                      </td>
                    </template>
                  </tr>
                  <tr>
                    <template v-for="(oc, index3) in anc.subcoursehole">
                      <td :key="index3 + 'op'">{{ oc.par_score }}</td>
                    </template>
                  </tr>
                  <tr>
                    <template v-for="(oc, index4) in anc.subcoursehole">
                      <td :key="index4 + 'od'">{{ oc.distance || 0 }}</td>
                    </template>
                  </tr>
                  <tr>
                    <template v-for="(oc, index5) in anc.subcoursehole">
                      <td :key="index5 + 'oc'">
                        <input
                          type="radio"
                          class="form-check-input custom-checkbox"
                          :value="index5 + index1 * 9 + 1"
                          v-model="form.hole"
                        />
                      </td>
                    </template>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </b-form>
  </div>
</template>

<script>
import "@/filter/common";
import ax from "@/api/event";

export default {
  name: "MiniGameWrite",
  data() {
    return {
      form: {
        title: "",
        message: "",
        point: 0,
        startdate: "",
        enddate: "",
        systemrange: 0,
        type: 1,
        distance: 0,
        courseno: "",
        hole: "",
        teebox: 1,
        gender: 0,
        status: "0",
      },
      eventno: this.$route.params.eventno || false,
      eventcourselist: [],
      courseview: [],
      courseview_yn: "n",
      distance_yn: "n",
      cc_par: [""],
    };
  },
  methods: {
    startDateChange(v) {
      this.form.startdate = v;
    },
    endDateChange(v) {
      this.form.enddate = v;
    },
    get_ownercourselist() {
      ax.get_ownercourselist((flag, data) => {
        if (flag) {
          this.eventcourselist = data.eventcourselist;
          //this.form.hole = ''
        } else {
          alert(data);
        }
      });
    },
    get_ownercourseview() {
      ax.get_ownercourseview(this.form.courseno, (flag, data) => {
        if (flag) {
          this.courseview = data.courseview;
          this.subcoursecnt = data.courseview.subcoursecnt;
          this.courseview.subcourse = data.courseview.subcourse;

          this.cc_par = [""];

          for (let i = 0; i < this.courseview.subcourse.length; i++) {
            this.courseview.subcourse.subcoursename =
              data.courseview.subcourse[i].subcoursename;
            this.courseview.subcourse.subcoursehole =
              data.courseview.subcourse[i].subcoursehole;

            for (
              let j = 0;
              j < this.courseview.subcourse.subcoursehole.length;
              j++
            ) {
              this.cc_par.push(
                this.courseview.subcourse.subcoursehole[j].par_score
              );
            }
          }
        } else {
          alert(data.message);
        }
      });
    },
    onSubmit(event) {
      event.preventDefault();
      if (this.form.title === "") {
        this.$notify({
          group: "alert",
          type: "warn",
          title: "Notice",
          text: this.$i18n.t("alert.minigame.enter_event_name"),
        });
        return false;
      }

      if (this.form.message === "") {
        this.$notify({
          group: "alert",
          type: "warn",
          title: "Notice",
          text: this.$i18n.t("alert.minigame.enter_your_screen_message"),
        });
        return false;
      }

      if (this.form.point === "") {
        this.$notify({
          group: "alert",
          type: "warn",
          title: "Notice",
          text: this.$i18n.t("alert.minigame.enter_bucks"),
        });
        return false;
      }

      if (this.form.startdate === "") {
        this.$notify({
          group: "alert",
          type: "warn",
          title: "Notice",
          text: this.$i18n.t("alert.minigame.enter_start_date"),
        });
        return false;
      }

      if (this.form.enddate === "") {
        this.$notify({
          group: "alert",
          type: "warn",
          title: "Notice",
          text: this.$i18n.t("alert.minigame.enter_end_date"),
        });
        return false;
      }

      if (this.form.courseno === "") {
        this.$notify({
          group: "alert",
          type: "warn",
          title: "Notice",
          text: this.$i18n.t("alert.minigame.enter_your_course_number"),
        });
        return false;
      }

      if (this.form.hole === "") {
        this.$notify({
          group: "alert",
          type: "warn",
          title: "Notice",
          text: this.$i18n.t("alert.minigame.select_winning_hole"),
        });
        return false;
      }

      if (this.eventno) {
        ax.set_ownereventedit(this.form, this.eventno, (flag, data) => {
          alert(data.message);
          if (flag) {
          } else {
            // this.$notify({
            //   group: "alert",
            //   type: "warn",
            //   title: "Notice",
            //   text: data,
            // });
            return false;
          }
        });
      } else {
        ax.set_ownereventwrite(this.form, (flag, data) => {
          alert(data.message);
          if (flag) {
            this.form.title = "";
            (this.form.message = ""),
              (this.form.point = 0),
              (this.form.startdate = ""),
              (this.form.enddate = ""),
              (this.form.systemrange = 0),
              (this.form.type = 0),
              (this.form.courseno = ""),
              (this.form.hole = ""),
              (this.form.teebox = 1),
              (this.form.gender = 0),
              (this.form.status = "0");
          } else {
            // this.$notify({
            //   group: "alert",
            //   type: "warn",
            //   title: "Notice",
            //   text: data,
            // });
            return false;
          }
        });
      }
    },
    get_ownereventview() {
      ax.get_ownereventview(this.eventno, (flag, data) => {
        if (flag) {
          this.form = data.eventinfo;
          this.form.startdate = this.$dayjs(
            this.form.timezone_startdate
          ).format("YYYY-MM-DD");
          this.form.enddate = this.$dayjs(this.form.timezone_enddate).format(
            "YYYY-MM-DD"
          );
          this.courseview_yn = "y";
          this.get_ownercourseview();
          if (data.eventinfo.type == "9" || data.eventinfo.type == "10") {
            this.distance_yn = "y";
          }
        } else {
          alert(data.message);
        }
      });
    },
    change_cc() {
      if (this.form.courseno !== "") {
        this.get_ownercourseview();
        this.courseview_yn = "y";
      } else {
        this.courseview_yn = "n";
      }
      this.form.hole = "";
    },
    change_type(event) {
      // alert(event.target.value);
      if (event.target.value == "9" || event.target.value == "10") {
        this.distance_yn = "y";
      } else {
        this.distance_yn = "n";
      }
      this.form.hole = "";
    },
  },
  created() {
    if (this.eventno) {
      this.get_ownereventview();
    }
    this.get_ownercourselist();
  },
};
</script>
<style scoped>
.course-table {
  position: relative;
}
.scorecard_title {
  width: 200px;

  position: absolute;
  top: 0;
  z-index: 10;
}

@media (max-width: 1200px) {
  .scorecard_title {
    width: 80px;
  }
}

.course-table .fix-table {
  width: calc(100% - 200px);
  margin-left: 200px;
}
.course-table .fix-table .table {
  width: 100%;
}

@media (max-width: 1199.98px) {
  .course-table .fix-table {
    margin-left: 80px;
    width: calc(100% - 80px);
  }
}

@media (min-width: 992px) and (max-width: 1199.98px) {
  .course-table .fix-table {
    width: calc(100% - 80px);
    margin-left: 80px;
  }
}

@media (max-width: 991.98px) {
  .course-table .fix-table {
    width: calc(100% - 80px);
    margin-left: 80px;
  }
  .course-table .fix-table .table {
    width: 100%;
  }
}
.event_edit div.fix-table.overflow-x-auto:nth-child(2) {
  margin-top: 40px;
}
</style>
